
<div>
  <button v-if="documents.length" class="btn btn-link text-primary text-decoration-none font-weight-bold" @click="toggleSelectAllDocuments" style="position: relative;right:12px ;">{{ allDocumentsSelected ? 'Unselect all document' : 'Select all document' }}</button>
  <v-row>
    <v-col cols="3">
      <div class="library-card border border-dashed d-flex justify-center align-center">
        <div role="button" class="text-center text-primary" @click="openUpload">
          <v-icon class="text-primary">mdi-upload-outline</v-icon><br>
          <span>Upload File</span>
        </div>
        <UploadDocumentModal :dialog="showUpload" @toggle-modal="toggleDialog"/>
      </div>
    </v-col>
    <Card v-for="file in documents" :key="file.id" :file="file" :isSelected="isSelected(file.id)" @toggle-selection="handleToggleSelection"/>
    <BottomActionBar v-if="selectedDocuments.length" :selected-documents="selectedDocuments" @clear-selection="clearSelection" />
  </v-row>
</div >
